export const SET_AIRLINES_OFFSET_LIMIT = 'SET_AIRLINES_OFFSET_LIMIT';
export const FETCH_AIRLINES_START = 'FETCH_AIRLINES_START';
export const FETCH_AIRLINES_SUCCESS = 'FETCH_AIRLINES_SUCCESS';
export const FETCH_AIRLINES_FAIL = 'FETCH_AIRLINES_FAIL';
export const SET_AIRLINES_PAGE = 'SET_AIRLINES_PAGE';

export const SET_AIRCRAFT_OFFSET_LIMIT = 'SET_AIRCRAFT_OFFSET_LIMIT';
export const FETCH_AIRCRAFT_START = 'FETCH_AIRCRAFT_START';
export const FETCH_AIRCRAFT_SUCCESS = 'FETCH_AIRCRAFT_SUCCESS';
export const FETCH_AIRCRAFT_FAIL = 'FETCH_AIRCRAFT_FAIL';
export const SET_AIRCRAFT_PAGE = 'SET_AIRCRAFT_PAGE';
export const UNMOUNT_AIRCRAFT = 'UNMOUNT_AIRCRAFT';

export const SET_AIRPORTS_OFFSET_LIMIT = 'SET_AIRPORTS_OFFSET_LIMIT';
export const FETCH_AIRPORTS_START = 'FETCH_AIRPORTS_START';
export const FETCH_AIRPORTS_SUCCESS = 'FETCH_AIRPORTS_SUCCESS';
export const FETCH_AIRPORTS_FAIL = 'FETCH_AIRPORTS_FAIL';
export const SET_AIRPORTS_PAGE = 'SET_AIRPORTS_PAGE';
export const UNMOUNT_AIRPORTS = 'UNMOUNT_AIRPORTS';
export const FETCH_METARS_START = 'FETCH_METARS_START';
export const FETCH_METARS_SUCCESS = 'FETCH_METARS_SUCCESS';
export const FETCH_METARS_FAIL = 'FETCH_METARS_FAIL';

export const SET_FLIGHTS_OFFSET_LIMIT = 'SET_FLIGHTS_OFFSET_LIMIT';
export const FETCH_FLIGHTS_START = 'FETCH_FLIGHTS_START';
export const FETCH_FLIGHTS_SUCCESS = 'FETCH_FLIGHTS_SUCCESS';
export const FETCH_FLIGHTS_FAIL = 'FETCH_FLIGHTS_FAIL';
export const SET_FLIGHTS_PAGE = 'SET_FLIGHTS_PAGE';
export const UNMOUNT_FLIGHTS = 'UNMOUNT_FLIGHTS';

export const SET_AKRX_OFFSET_LIMIT = 'SET_AKRX_OFFSET_LIMIT';
export const FETCH_AKRX_START = 'FETCH_AKRX_START';
export const FETCH_AKRX_SUCCESS = 'FETCH_AKRX_SUCCESS';
export const FETCH_AKRX_FAIL = 'FETCH_AKRX_FAIL';
export const SET_AKRX_PAGE = 'SET_AKRX_PAGE';

export const SET_AKRX_OFFSET_LIMIT_ALL = 'SET_AKRX_OFFSET_LIMIT_ALL';
export const FETCH_AKRX_START_ALL = 'FETCH_AKRX_START_ALL';
export const FETCH_AKRX_SUCCESS_ALL = 'FETCH_AKRX_SUCCESS_ALL';
export const FETCH_AKRX_FAIL_ALL = 'FETCH_AKRX_FAIL_ALL';
export const SET_AKRX_PAGE_ALL = 'SET_AKRX_PAGE_ALL';

export const SET_USERS_OFFSET_LIMIT = 'SET_USERS_OFFSET_LIMIT';
export const FETCH_USERS_START = 'FETCH_USERS_START';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAIL = 'FETCH_USERS_FAIL';
export const SET_USERS_PAGE = 'SET_USERS_PAGE';
export const FETCH_USER_START = 'FETCH_USER_START';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAIL = 'FETCH_USER_FAIL';

export const SET_ADSB_OFFSET_LIMIT = 'SET_ADSB_OFFSET_LIMIT';
export const FETCH_ADSB_START = 'FETCH_ADSB_START';
export const FETCH_ADSB_SUCCESS = 'FETCH_ADSB_SUCCESS';
export const FETCH_ADSB_FAIL = 'FETCH_ADSB_FAIL';
export const SET_ADSB_PAGE = 'SET_ADSB_PAGE';

export const SET_ADSB_OFFSET_LIMIT_COMPANY = 'SET_ADSB_OFFSET_LIMIT_COMPANY';
export const FETCH_ADSB_START_COMPANY = 'FETCH_ADSB_START_COMPANY';
export const FETCH_ADSB_SUCCESS_COMPANY = 'FETCH_ADSB_SUCCESS_COMPANY';
export const FETCH_ADSB_FAIL_COMPANY = 'FETCH_ADSB_FAIL_COMPANY';
export const SET_ADSB_PAGE_COMPANY = 'SET_ADSB_PAGE_COMPANY';

export const SET_ACARSWITHEXTDATA_OFFSET_LIMIT = 'SET_ACARSWITHEXTDATA_OFFSET_LIMIT';
export const SET_ACARSWITHEXTDATA_PAGE = 'SET_ACARSWITHEXTDATA_PAGE';    
export const FETCH_ACARSWITHEXTDATA_START = 'FETCH_ACARSWITHEXTDATA_START';        
export const FETCH_ACARSWITHEXTDATA_SUCCESS = 'FETCH_ACARSWITHEXTDATA_SUCCESS';         
export const FETCH_ACARSWITHEXTDATA_FAIL = 'FETCH_ACARSWITHEXTDATA_FAIL';

export const SET_ACARSWITHEXTDATA_OFFSET_LIMIT_COMPANY = 'SET_ACARSWITHEXTDATA_OFFSET_LIMIT_COMPANY';
export const SET_ACARSWITHEXTDATA_PAGE_COMPANY = 'SET_ACARSWITHEXTDATA_PAGE_COMPANY';    
export const FETCH_ACARSWITHEXTDATA_START_COMPANY = 'FETCH_ACARSWITHEXTDATA_START_COMPANY';        
export const FETCH_ACARSWITHEXTDATA_SUCCESS_COMPANY = 'FETCH_ACARSWITHEXTDATA_SUCCESS_COMPANY';         
export const FETCH_ACARSWITHEXTDATA_FAIL_COMPANY = 'FETCH_ACARSWITHEXTDATA_FAIL_COMPANY';

export const FETCH_AIRCRAFTTYPE_START = 'FETCH_AIRCRAFTTYPE_START';
export const FETCH_AIRCRAFTTYPE_SUCCESS = 'FETCH_AIRCRAFTTYPE_SUCCESS';
export const FETCH_AIRCRAFTTYPE_FAIL = 'FETCH_AIRCRAFTTYPE_FAIL';

export const FETCH_TYPECODE_START = 'FETCH_TYPECODE_START';
export const FETCH_TYPECODE_SUCCESS = 'FETCH_TYPECODE_SUCCESS';
export const FETCH_TYPECODE_FAIL = 'FETCH_TYPECODE_FAIL';

export const FETCH_CURRENTLOCATION_START = "FETCH_CURRENTLOCATION_START";
export const FETCH_CURRENTLOCATION_SUCCESS = "FETCH_CURRENTLOCATION_SUCCESS";
export const FETCH_CURRENTLOCATION_FAIL = "FETCH_CURRENTLOCATION_FAIL";
export const FETCH_STATES_START = "FETCH_STATES_START"; 
export const FETCH_STATES_SUCCESS = "FETCH_STATES_SUCCESS";
export const FETCH_STATES_FAIL = "FETCH_STATES_FAIL";
export const FETCH_OPENSKYS_START = "FETCH_OPENSKYS_START";
export const FETCH_OPENSKYS_SUCCESS = "FETCH_OPENSKYS_SUCCESS";
export const FETCH_OPENSKYS_FAIL = "FETCH_OPENSKYS_FAIL";

export const FETCH_CURRENTLOCATION_START_COMPANY = "FETCH_CURRENTLOCATION_START_COMPANY";
export const FETCH_CURRENTLOCATION_SUCCESS_COMPANY = "FETCH_CURRENTLOCATION_SUCCESS_COMPANY";
export const FETCH_CURRENTLOCATION_FAIL_COMPANY = "FETCH_CURRENTLOCATION_FAIL_COMPANY";

export const FETCH_ROUTES_START = "FETCH_ROUTES_START";
export const FETCH_ROUTES_SUCCESS = "FETCH_ROUTES_SUCCESS";
export const FETCH_ROUTES_FAIL = "FETCH_ROUTES_FAIL";

export const FETCH_AIRCRAFTJSON_START = "FETCH_AIRCRAFTJSON_START";
export const FETCH_AIRCRAFTJSON_SUCCESS = "FETCH_AIRCRAFTJSON_SUCCESS";
export const FETCH_AIRCRAFTJSON_FAIL = "FETCH_AIRCRAFTJSON_FAIL";

export const DECODING_START = "DECODING_START";
export const DECODING_SUCCESS = "DECODING_SUCCESS";
export const DECODING_FAIL = "DECODING_FAIL";

export const STATISTICS_START = "STATISTICS_START";
export const STATISTICS_SUCCESS = "STATISTICS_SUCCESS";
export const STATISTICS_FAIL = "STATISTICS_FAIL";

export const DIRECTIONALRANGES_START = "DIRECTIONALRANGES_START";
export const DIRECTIONALRANGES_SUCCESS = "DIRECTIONALRANGES_SUCCESS";
export const DIRECTIONALRANGES_FAIL = "DIRECTIONALRANGES_FAIL";

export const FEEDINGTIME_START = "FEEDINGTIME_START";
export const FEEDINGTIME_SUCCESS = "FEEDINGTIME_SUCCESS";
export const FEEDINGTIME_FAIL = "FEEDINGTIME_FAIL";

export const FEEDINGWORKPERCENTAGEDTOS_START = "FEEDINGWORKPERCENTAGEDTOS_START";
export const FEEDINGWORKPERCENTAGEDTOS_SUCCESS = "FEEDINGWORKPERCENTAGEDTOS_SUCCESS";
export const FEEDINGWORKPERCENTAGEDTOS_FAIL = "FEEDINGWORKPERCENTAGEDTOS_FAIL";

export const FEEDINGPERCENTAGEPERMESSAGETYPE_START = "FEEDINGPERCENTAGEPERMESSAGETYPE_START";
export const FEEDINGPERCENTAGEPERMESSAGETYPE_SUCCESS = "FEEDINGPERCENTAGEPERMESSAGETYPE_SUCCESS";
export const FEEDINGPERCENTAGEPERMESSAGETYPE_FAIL = "FEEDINGPERCENTAGEPERMESSAGETYPE_FAIL";

export const STATIONDATA_START = "STATIONDATA_START";
export const STATIONDATA_SUCCESS = "STATIONDATA_SUCCESS";
export const STATIONDATA_FAIL = "STATIONDATA_FAIL";

export const SET_STATIONSTATUS_OFFSET_LIMIT = 'SET_STATIONSTATUS_OFFSET_LIMIT';
export const FETCH_STATIONSTATUS_START = 'FETCH_STATIONSTATUS_START';
export const FETCH_STATIONSTATUS_SUCCESS = 'FETCH_STATIONSTATUS_SUCCESS';
export const FETCH_STATIONSTATUS_FAIL = 'FETCH_STATIONSTATUS_FAIL';
export const SET_STATIONSTATUS_PAGE = 'SET_STATIONSTATUS_PAGE';

export const STATIONNUMBER_START = "STATIONNUMBER_START";
export const STATIONNUMBER_SUCCESS = "STATIONNUMBER_SUCCESS";
export const STATIONNUMBER_FAIL = "STATIONNUMBER_FAIL";

export const SET_STATIONSTATUSFRAMESIZE_OFFSET_LIMIT = 'SET_STATIONSTATUSFRAMESIZE_OFFSET_LIMIT';
export const FETCH_STATIONSTATUSFRAMESIZE_START = 'FETCH_STATIONSTATUSFRAMESIZE_START';
export const FETCH_STATIONSTATUSFRAMESIZE_SUCCESS = 'FETCH_STATIONSTATUSFRAMESIZE_SUCCESS';
export const FETCH_STATIONSTATUSFRAMESIZE_FAIL = 'FETCH_STATIONSTATUSFRAMESIZE_FAIL';
export const SET_STATIONSTATUSFRAMESIZE_PAGE = 'SET_STATIONSTATUSFRAMESIZE_PAGE';